export default function AboutHero() {
  return (
    <section className="relative pt-32 pb-20 bg-gradient-to-br from-blue-50 to-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            About TrackVerse
          </h1>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Founded in 2020 by Michael Ashley, TrackVerse has revolutionized global logistics 
            with innovative tracking solutions and comprehensive import-export services. We connect 
            businesses and individuals across continents, making international shipping transparent, 
            secure, and efficient.
          </p>
          <div className="flex justify-center gap-8 mt-12">
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-600">2020</div>
              <div className="text-sm text-gray-600 mt-2">Founded</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-green-600">50+</div>
              <div className="text-sm text-gray-600 mt-2">Countries</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-600">1M+</div>
              <div className="text-sm text-gray-600 mt-2">Shipments</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-green-600">24/7</div>
              <div className="text-sm text-gray-600 mt-2">Support</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
